export default __webpack_public_path__ + "static/media/svg-4.b4c90c20.svg";